import { AnimatePresence, motion } from "framer-motion";

import LoadingSpinner from "@/components/LoadingSpinner";
import { SigningInWelcomeCard } from "@/components/SigningInWelcomeCard";
import { ChooseWorkspaceAndRedirect } from "@/UserIndex";
import { OnboardingFlowProvider, useOnboardingFlow } from "@/context/onboarding-flow-context";
import { ObservabilitySetup } from "@/routes/onboarding/ObservabilitySetup";
import { Onboarding } from "@/routes/onboarding/page";
import {
  ONBOARDING_GUARD_STATUS,
  useOnboardingGuardState,
} from "@/routes/onboarding/hooks/useOnboardingGuardState";

const OnboardingGuardContent = () => {
  const { onboardingPath } = useOnboardingFlow();
  const status = useOnboardingGuardState(onboardingPath);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={status}
        className={status === ONBOARDING_GUARD_STATUS.LOADING ? "h-full" : undefined}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        {status === ONBOARDING_GUARD_STATUS.LOADING && (
          <div className="flex h-full items-center justify-center">
            <LoadingSpinner delay={1000} />
          </div>
        )}
        {status === ONBOARDING_GUARD_STATUS.REDIRECT && (
          <>
            <SigningInWelcomeCard />
            <ChooseWorkspaceAndRedirect />
          </>
        )}
        {status === ONBOARDING_GUARD_STATUS.ONBOARDING && <Onboarding />}
        {status === ONBOARDING_GUARD_STATUS.OBSERVABILITY_SETUP && <ObservabilitySetup />}
      </motion.div>
    </AnimatePresence>
  );
};

export const OnboardingGuard = () => (
  <OnboardingFlowProvider>
    <OnboardingGuardContent />
  </OnboardingFlowProvider>
);
